/**
 * Theme registry — keys map to [data-theme="…"] overrides in index.css.
 * 'electric' is the default and corresponds to the bare :root tokens.
 */
export type ThemeKey =
  | 'electric'
  | 'indigo'
  | 'teal'
  | 'coral'
  | 'mono'
  | 'midnight'

export interface ThemeMeta {
  key: ThemeKey
  label: string
  description: string
  /** Hex used in the profile picker's mini preview. */
  accent: string
  bg: string
  surface: string
  text: string
}

export const THEMES: ThemeMeta[] = [
  {
    key: 'electric',
    label: 'Electric Blue',
    description: "L'actuelle — pro, lisible",
    accent: '#2563eb',
    bg: '#f4f7fc',
    surface: '#ffffff',
    text: '#0f172a',
  },
  {
    key: 'indigo',
    label: 'Indigo Premium',
    description: 'Sophistiqué, créatif',
    accent: '#6d28d9',
    bg: '#f6f4fb',
    surface: '#ece6f5',
    text: '#1e1b4b',
  },
  {
    key: 'teal',
    label: 'Teal Productivité',
    description: 'Frais, calme',
    accent: '#0d9488',
    bg: '#f1f9f7',
    surface: '#e3f1ec',
    text: '#0f172a',
  },
  {
    key: 'coral',
    label: 'Sunset Coral',
    description: 'Chaleureux, énergique',
    accent: '#ea580c',
    bg: '#fcf6ef',
    surface: '#f6eadd',
    text: '#1c1917',
  },
  {
    key: 'mono',
    label: 'Monochrome Ink',
    description: 'Éditorial, intemporel',
    accent: '#0a0a0a',
    bg: '#fafafa',
    surface: '#ffffff',
    text: '#0a0a0a',
  },
  {
    key: 'midnight',
    label: 'Midnight Lime',
    description: 'Mode sombre, dev tool',
    accent: '#84cc16',
    bg: '#020617',
    surface: '#1e293b',
    text: '#f1f5f9',
  },
]

export const DEFAULT_THEME: ThemeKey = 'electric'

export function isThemeKey(value: unknown): value is ThemeKey {
  return (
    typeof value === 'string' && THEMES.some((t) => t.key === (value as ThemeKey))
  )
}
